import React, { useEffect, useRef } from "react";
import { Row, Col } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import PaymentForm from "../Payment/Payment";
import PaymentInfoCard from "../../../../../../CommonComponents/Cards/PaymentInfoCard/PaymentInfoCard";
import TooltipComponent from "../../../../../../CommonComponents/Info/Tooltip/TooltipComponent";
import { dateFormatter } from "../../../../../../utils/commonUtil";
import ReactDOM from "react-dom";

import {
  GrantAgreementSectionLastHeading,
  GrantAgreementSubContent,
  GrantPillButton,
  FloatCard,
  CardWrapper,
  GrantTermWrapper,
  FloaterContainer,
} from "../../styles";
import { CapsuleButton } from "../../../../../../CommonComponents/Commons/commonComponents";
function GrantPayment(props) {
  const {
    amount,
    remainingAmountFinder,
    payment,
    disableDate,
    paymentChange,
    dateChange,
    blurHandler,
    radioChange,
    addPayment,
    grantTermDates,
    removePayment,
    grantPurposeDropdown,
  } = props;

  const useStickyFloatCard = (floatingCard) => {
    useEffect(() => {
      let bodyRect = document.body.getBoundingClientRect();
      let sticky = floatingCard.current;
      let elemRect = sticky ? sticky.getBoundingClientRect() : null;
      let elemOffset = elemRect ? elemRect.top - bodyRect.top : null;
      let gawSticky = gawPayment.current;
      const handleScroll = (e) => {
        if (elemOffset) {
          let gawStickyScroll = gawSticky.getBoundingClientRect();
          if (gawStickyScroll.top < 0 && gawStickyScroll.bottom > 415) {
            sticky.classList.remove("fixed-bottom");
            sticky.classList.remove("default");
            sticky.classList.add("fixed-top");
          } else if (gawStickyScroll.bottom <= 415) {
            sticky.classList.remove("default");
            sticky.classList.remove("fixed-top");
            sticky.classList.add("fixed-bottom");
          } else {
            sticky.classList.remove("fixed-top");
            sticky.classList.remove("fixed-bottom");
            sticky.classList.add("default");
          }
        }
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    });
  };
  const gawPayment = useRef(null);
  const floatingCard = useRef(null);
  useStickyFloatCard(floatingCard);

  return (
    <div id="gaw-payment" ref={gawPayment}>
      <GrantAgreementSectionLastHeading>
        Grant agreement payments{" "}
        <TooltipComponent text="The total grant agreement amount can be a lump sum or split over multi-year payments, with a maximum of five" />
      </GrantAgreementSectionLastHeading>
      <GrantAgreementSubContent>
        Please decide the timing and distribution of the grant payments. Up to
        five payments are allowed.{" "}
      </GrantAgreementSubContent>

      {window.innerWidth > 728 ? (
        <FloaterContainer>
          <FloatCard ref={floatingCard} className="default dimension">
            <CardWrapper>
              <PaymentInfoCard
                totalAmount={amount}
                remainingAmount={remainingAmountFinder()}
              />
            </CardWrapper>
          </FloatCard>
        </FloaterContainer>
      ) : null}
      <Row>
        <Col>
          {payment.length &&
            payment.map((singlePayment, index) => (
              <PaymentForm
                index={index}
                paymentCount={payment.length}
                disableDate={disableDate}
                payment={singlePayment}
                paymentChange={paymentChange}
                dateChange={dateChange}
                handleBlur={blurHandler}
                radioChange={radioChange}
                removePayment={removePayment}
                grantPurposeDropdown={grantPurposeDropdown}
              />
            ))}
          {remainingAmountFinder() > 0 && payment.length <= 4 && (
            <CapsuleButton
              onClick={() => addPayment()}
              text="Add another payment +"
            ></CapsuleButton>
          )}
          <GrantTermWrapper paddingBottom>
            Grant Term:&nbsp;
            {grantTermDates && grantTermDates.startDate
              ? dateFormatter(grantTermDates.startDate)
              : "Start date"}
            &nbsp; to&nbsp;
            {grantTermDates && grantTermDates.endDate
              ? dateFormatter(grantTermDates.endDate)
              : "End date"}
          </GrantTermWrapper>
        </Col>
      </Row>
      <div class="mt-10"></div>
    </div>
  );
}

GrantPayment.propTypes = {
  addPayment: PropTypes.func,
  amount: PropTypes.string,
  blurHandler: PropTypes.func,
  dateChange: PropTypes.func,
  disableDate: PropTypes.func,
  grantPurposeDropdown: PropTypes.string,
  grantTermDates: PropTypes.object,
  payment: PropTypes.array,
  paymentChange: PropTypes.func,
  radioChange: PropTypes.func,
  remainingAmountFinder: PropTypes.func,
  removePayment: PropTypes.func,
};

export default GrantPayment;
